<template>
	<div id="modal-inventory-products-show-image">
		<b-modal :id="modalName" title="Image Preview" scrollable hide-footer>
            <b-container fluid class="text-center">
                <b-img :src="url"></b-img>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
	export default {
		props: [
			'url'
		],

		data() {
			return {
				modalName: 'modal-inventory-products-show-image'
			}
		},

		methods: {
            
		}
	}
</script>

<style lang="scss">
    #modal-inventory-products-show-image {
        
    }
</style>